import { useParams } from "../../../router-utils"
import { AutomationTemplateDefinitionPage } from "../../../Automations"

export default function EditAutomationPage() {
	const { automationId } = useParams("/automations/:automationId/edit")

	if (!automationId) {
		return null
	}

	return <AutomationTemplateDefinitionPage automationId={automationId} />
}
